export default __webpack_public_path__ + "static/media/signupImage3.79a10ac5.png";